import { configureStore } from '@reduxjs/toolkit';
import themeReducer from '../features/theme/themeslice';
import navReducer from '../features/nav/navslice';
import modalReducer from '../features/modal/modalSlice'; // if added

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    modal: modalReducer,
    nav: navReducer,
  },
});